export default "__VITE_ASSET__C2H17g1N__"